import { Tabletop } from '@/components/tabletop';

function App() {
  return (
    <main className="relative min-h-screen overflow-hidden">
      <div className="h-screen w-full">
        <Tabletop />
      </div>
    </main>
  );
}

export default App;
